class IbcBannerComponent extends HTMLElement {

  connectedCallback() {
    const template = document.createElement('template');
    const linkUrl = this.getAttribute('url') ? this.getAttribute('url') : 'https://createctrl.com/en/ibc2024';
    const target = this.getAttribute('target') ? this.getAttribute('target') : '_self';

    //language=html
    template.innerHTML = `
      <style>
        * {
          padding: 0;;
          margin: 0;
          box-sizing: border-box;
        }
        
        .ibc-banner-wrapper {
          width: calc(100% - 16px);
          max-width: 384px;
          position: fixed;
          bottom: 8px;
          right: 8px;
          z-index: 1000;
          font-family: "Segoe UI", sans-serif;
          background-color: #ffffff;
          background-image: url("https://createctrl-assets.s3.eu-central-1.amazonaws.com/images/IBC_2024.png");
          background-size: cover;
          text-transform: uppercase;
          padding: 32px 16px;
          box-shadow: 0 4px 10px 0 #00000040;
        }
        
        .d-none {
          display: none !important;
        }
        
        .ibc-banner-wrapper h4 {
          font-size: 64px;
          color: #FF5500;
        }

        .ibc-banner-wrapper h5 {
          font-size: 32px;
          color: #5D5D5D;
        }
        
        .ibc-banner-wrapper p {
          font-size: 14px;
          color: #686868;
          margin-top: 19px;
        }
        
        .ibc-banner-wrapper .link-button {
          margin-top: 123px;
          background-color: #FFFFFF;
          color: #424242;
          font-size: 12px;
          padding: 11px 24px;
          border-radius: 5px;
          display: inline-block;
          text-decoration: none;
          font-weight: bold;
        }
        
        .ibc-banner-wrapper .close-button {
          position: absolute;
          top: 16px;
          right: 16px;
          cursor: pointer;
          border: 0;
          background: transparent;
        }
      </style>
      <div class="ibc-banner-wrapper">
        <button class="close-button">
          <img src="https://createctrl-assets.s3.eu-central-1.amazonaws.com/images/close-icon.svg" alt="close button" width="14" height="14">
        </button>
        
        <h4>MEET US</h4>
        <h5>
          AT IBC 2024
        </h5>
        <p>
          Booth: 1.B13<br>
          13-16 September
        </p>
        
        <a href="${ linkUrl }" class="link-button" target="${ target }">
          READ MORE
        </a>
      </div>
    `;

    this.attachShadow({ mode: 'open' })
    this.shadowRoot.appendChild(template.content.cloneNode(true));
    this.shadowRoot.host.classList.add('d-none');

    if (!localStorage.getItem('isIBC2024BannerHidden')) {
      this.shadowRoot.host.classList.remove('d-none');
    }

    this.closeButtonActions();
  }

  closeButtonActions() {
    const closeButton = this.shadowRoot.querySelector('.close-button');

    closeButton.addEventListener('click', () => {
      this.remove();
      localStorage.setItem('isIBC2024BannerHidden', '1');
    });
  }
}

window.customElements.define('cc-ibc-banner', IbcBannerComponent);
